import { useTranslation } from "react-i18next";

export default function HeroSection() {
  const { t } = useTranslation();

  const scrollToAbout = () => {
    const el = document.getElementById("about");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/bf56f3fdd58185c1ad57cd904c0ce8f0.jpg"
          alt="Modern clinic interior"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0F1410]/55 via-[#0F1410]/35 to-[#0F1410]/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full flex flex-col items-center text-center px-8 max-w-4xl mx-auto">
        <div
          className="inline-block text-[11px] tracking-[0.25em] uppercase text-white/70 font-medium mb-8 border border-white/25 px-5 py-2 rounded-full"
          style={{ fontFamily: "'DM Sans', sans-serif" }}
        >
          {t("hero.badge")}
        </div>

        <h1
          className="text-6xl md:text-7xl font-light text-white mb-6 leading-tight"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          {t("hero.title1")}<br />
          <em className="font-normal italic">{t("hero.title2")}</em>
        </h1>

        <p
          className="text-white/75 text-lg font-light max-w-xl leading-relaxed mb-12"
          style={{ fontFamily: "'DM Sans', sans-serif" }}
        >
          {t("hero.description")}
        </p>

        <div className="flex items-center gap-5 flex-wrap justify-center">
          <button
            onClick={scrollToAbout}
            className="px-8 py-3.5 bg-white text-[#2F5547] text-[13px] tracking-widest uppercase font-medium rounded-md hover:bg-[#F0EDE8] transition-colors duration-300 cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            {t("hero.learnMore")}
          </button>
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="px-8 py-3.5 border border-white/50 text-white text-[13px] tracking-widest uppercase font-medium rounded-md hover:border-white/90 hover:bg-white/10 transition-all duration-300 cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            {t("hero.contactUs")}
          </a>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 z-10 opacity-60">
        <div
          className="text-[10px] tracking-[0.2em] uppercase text-white font-medium"
          style={{ fontFamily: "'DM Sans', sans-serif" }}
        >
          {t("hero.scroll")}
        </div>
        <div className="w-px h-10 bg-gradient-to-b from-white to-transparent" />
      </div>
    </section>
  );
}
